const ProductTypes = {
    PAY_PER_LEAD: 'Zillow Rent Connect™',
    PAY_PER_CLICK: 'Zillow Rent Connect™',
    FLAT_FEE: 'Zillow Rent Connect™',
    PAY_PER_LEASE: 'Zillow Lease Connect™',
    INTEGRATED_PAY_PER_LEASE: 'Zillow Lease Connect™',
    CONCIERGE_PAY_PER_LEASE: 'Zillow Lease Connect™',
    SINGLE_FAMILY: 'Single Family',
    SINGLE_FAMILY_DAILY_LISTINGS: 'Zillow Feed Connect™',
    BASE_PACKAGE: 'Base Package',
    ENHANCED_PACKAGE: 'Enhanced Package',
    PREMIUM_PACKAGE: 'Premium Package',
    PREMIUM_PLUS_PACKAGE: 'Premium Plus Package',
};

const AdproductsConstants = {
    ProductTypes,
};

export default AdproductsConstants;
